import { TextField } from "@mui/material";
import { useContext } from "react";

import Context from "../../context";
import ContextTable from "../../TransactionsTable/contextTable";
import useGetManageCompanies from "../service/useGetManageCompanies";

export default function CifFilterInput() {
	const { actions, state } = useContext(Context);
	const { getManageCompanies } = useGetManageCompanies();
	const { onChangePage } = useContext(ContextTable);

	const onChangeTerm = (value: string) => {
		actions.onChangeTerm(value);
		getManageCompanies(0, value, state.nullCifOnly, () => onChangePage(null, 0));
	};

	return (
		<TextField
			value={state.term}
			size='small'
			sx={{ width: 200 }}
			placeholder='Añade un CIF'
			onChange={(e) => onChangeTerm(e.target.value)}
		/>
	);
}
